/* Tiny Hearts: public course sold-out + waitlist.
   When a course has no bookable dates left, show "Sold out" and swap the
   Add to cart button for "Join the waitlist".
   Uses the SAME booking API and the SAME definition of availability as the
   calendar in zone-picker.js, so the two can never disagree.

   The waitlist button opens the Klaviyo popup. If that popup does not open for
   ANY reason (form still in draft, wrong id, Klaviyo slow or blocked), the
   button falls back to /pages/waitlist, which is the behaviour that shipped on
   1 Oct. The button can never be dead. */
(function () {
  var API = 'https://tinyhearts-booking.com/api/getInfo?pid=';
  var WAITLIST_PAGE = '/pages/waitlist';
  var KLAVIYO_FORM_ID = 'Xfwqwe';
  var CITY_FIELD = '.th-waitlist-city';

  function courseTitle() {
    var meta = document.querySelector('meta[property="og:title"]');
    return (meta ? meta.getAttribute('content') : document.title) || '';
  }

  function cityFromTitle() {
    var t = courseTitle().trim();
    return t ? t.split(' ')[0] : '';
  }

  function injectStyles() {
    if (document.getElementById('th-soldout-styles')) return;
    var s = document.createElement('style');
    s.id = 'th-soldout-styles';
    s.textContent =
      '.th-course-soldout .c-zone-picker__time-slot-button{pointer-events:none;opacity:.55;}' +
      '.th-waitlist-button{display:block;text-align:center;text-decoration:none !important;cursor:pointer;}';
    document.head.appendChild(s);
  }

  /* Keep trying until the Klaviyo city field exists. A single timed attempt
     loses the city on a slow load, and nobody would ever find out. */
  function injectCity(city, attempt) {
    attempt = attempt || 0;
    var wrap = document.querySelector(CITY_FIELD);
    var input = wrap ? wrap.querySelector('input') : null;
    if (input) {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      setter.call(input, city);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (attempt < 40) {
      setTimeout(function () { injectCity(city, attempt + 1); }, 150);
    }
  }

  /* Must detect THIS form specifically. The generic Klaviyo class is on every
     Klaviyo element, including the 15% welcome popup that already fires on
     product pages, which would mask a failure. */
  function waitlistFormIsOpen() {
    return !!(
      document.querySelector('.klaviyo-form-' + KLAVIYO_FORM_ID) ||
      document.querySelector(CITY_FIELD)
    );
  }

  function openWaitlist(event, href, city) {
    if (!window._klOnsite || !KLAVIYO_FORM_ID) return; // let the link navigate
    event.preventDefault();

    // Put the city on the URL so Klaviyo can also pick it up natively.
    try {
      var u = new URL(window.location.href);
      if (city && u.searchParams.get('city') !== city) {
        u.searchParams.set('city', city);
        window.history.replaceState(null, '', u.toString());
      }
    } catch (e) {}

    try {
      window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]);
    } catch (e) {
      window.location.href = href;
      return;
    }

    if (city) injectCity(city, 0);

    // If this form did not open, go to the page rather than leaving a dead button.
    setTimeout(function () {
      if (!waitlistFormIsOpen()) window.location.href = href;
    }, 1500);
  }

  function showSoldOut() {
    injectStyles();

    var wrap = document.querySelector('.c-course-product');
    if (wrap) wrap.classList.add('th-course-soldout');

    var labels = document.querySelectorAll('label.o-paragraph--3');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.toLowerCase().indexOf('find a slot') > -1) {
        labels[i].textContent = 'Sold out';
      }
    }

    var placeholder = document.querySelector('[data-date-time-slot]');
    if (placeholder) placeholder.textContent = 'No dates available';

    var atc = document.querySelector('[data-confirm-atc-button]');
    if (!atc) return;
    if (document.querySelector('[data-waitlist-button]')) return;

    var city = cityFromTitle();
    var href = WAITLIST_PAGE +
      '?city=' + encodeURIComponent(city) +
      '&course=' + encodeURIComponent(courseTitle()) +
      '&productId=' + encodeURIComponent(window.tbe && window.tbe.product_id ? window.tbe.product_id : '');

    var link = document.createElement('a');
    link.setAttribute('data-waitlist-button', '');
    link.className = 'product-form__submit button button--primary book-continue th-waitlist-button';
    link.href = href;
    link.innerHTML = '<span>Join the waitlist</span>';
    link.addEventListener('click', function (e) { openWaitlist(e, href, city); });

    atc.hidden = true;
    atc.style.display = 'none';
    atc.parentNode.insertBefore(link, atc.nextSibling);
  }

  function check() {
    if (!window.tbe || !window.tbe.product_id) return;
    fetch(API + window.tbe.product_id)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var days = parseInt(data && data.cutoff_days, 10) || 0;
        var cutoff = new Date(Date.now() + days * 86400000).toISOString();
        var dates = (data && data.dates) || [];
        var bookable = dates.filter(function (b) {
          return Number(b.booked) < Number(b.capacity) &&
            new Date(b.datetime + '+11:00').toISOString() > cutoff;
        });
        if (bookable.length === 0) showSoldOut();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();